import { useRef } from "react"
import { NumberInput } from "source/shared/components/NumberInput"
import {
  ChurchCenterCustomFieldApiRecordWithRelationships,
  UpdateCustomFieldAttributes,
} from "source/myChurchCenter/Profile/types"
import { Icon } from "source/shared/components"

export function Number({
  customField,
  updateAttributes,
}: {
  customField: ChurchCenterCustomFieldApiRecordWithRelationships
  updateAttributes: UpdateCustomFieldAttributes
}) {
  const fieldName =
    customField.relationships.field_definition.data.attributes.name
  const fieldValue =
    customField.relationships.field_data?.data[0]?.attributes?.value || 0

  const {
    relationships: { field_data: fieldData },
  } = customField

  const {
    attributes: { editing_rules: editingRules },
  } = customField

  const valueRef = useRef(fieldValue)

  const config =
    customField.relationships?.field_definition?.data?.attributes?.config || {}
  const { min, max } = config

  const disabled =
    editingRules === "view" ||
    !!(editingRules === "add_if_blank" && valueRef.current)

  return (
    <div key={customField.id}>
      <div className="d-f">
        <label htmlFor={fieldName}>{fieldName}</label>
        {disabled && <Icon symbol="general#lock" className="fs-2 pl-1 pt-1" />}
      </div>
      <NumberInput
        id={`${customField.id}-number-input`}
        disabled={disabled}
        placeholder="Enter a value"
        min={min}
        step={1}
        max={max}
        name={fieldName}
        onBlur={() => {}}
        onChange={(e: { target: { value: string } }) =>
          updateAttributes({
            customField,
            record: fieldData?.data[0] || null,
            attributes: { value: e.target.value },
          })
        }
        onKeyDown={() => {}}
        value={fieldValue || String(min)}
      />
    </div>
  )
}
